import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_56 } from "@/lib/programData";
export default function DesiertoAtlas56Page() {
  return <ProgramTemplate program={PROGRAM_56} variant="da" showJourneyChronology />;
}
